import {MessageWithMetadata, KAIResponseType, Artifact} from "../../../types";

const baseMessage = () => ({
    sources: [],
    relatedTools: [],
    isRegenerated: false,
    timestamp: new Date().toISOString(),
    thoughts: [],
    activities: [],
    pluginActivities: [],
});

export function createUserMessage(
    content: string,
    position = 0,
    options?: {artifacts?: Artifact[]}
): MessageWithMetadata {
    return {
        role: "user",
        content,
        position,
        ...baseMessage(),
        ...(options?.artifacts?.length && {artifacts: options.artifacts}),
    } as MessageWithMetadata;
}

export function createAssistantMessage(
    position = 1,
    options?: {
        content?: string;
        responseType?: KAIResponseType;
        artifacts?: Artifact[];
    }
): MessageWithMetadata {
    return {
        role: "assistant",
        content: options?.content ?? "",
        position,
        ...baseMessage(),
        ...(options?.responseType !== undefined && {responseType: options.responseType}),
        ...(options?.artifacts && {artifacts: options.artifacts}),
    } as MessageWithMetadata;
}
